import { axiosApiService } from '../axios';

const EquipmentListAPIs = {
  EquipmentListGet: async function () {
    const response = await axiosApiService.get(`/admin_equipment_list/`);
    return response.data;
  },

  AddInventory: async function (values, token) {
    try {
      const response = await axiosApiService.post(
        `/admin_equipment_list/`,
        values
      );
      return response;
    } catch (error) {
      console.error('Error adding Equipment:', error);
      // You can choose to return an error response or throw an error
      throw error;
    }
  },
};
export default EquipmentListAPIs;
